export const IRE_CLICK_ID = 'ire_click_id';
export const CATEGORY_LIST = 'category_list';
export const CUSTOM_DIMENSION = 'custom_dimension';
export const SESSION_STORAGE_FLAG_ANALYTICS_LIST = 'session_storage_flag_events_list';
